import React from 'react';
// import AwesomeSlider from 'react-awesome-slider';
// import AwsSliderStyles from 'react-awesome-slider/src/styles';

//Компонента отображения даиграмм из пакета информационного обмена
class DiagramGallery extends React.Component {
  
    constructor(props, context) {
        super(props, context)
    }
    
    componentWillMount() { 
    }

    render() {
        console.log(this);
        // console.log(AwsSliderStyles);
        // console.log(this.refs.canvasSlider, window.innerHeight);
        // const recommendedHeight = window.innerHeight-100;
        // const recommendedWidth =  window.innerHeight;
        return (
            <div ref="canvasSlider">
                {/* <AwesomeSlider cssModule={AwsSliderStyles} style={{maxHeight: recommendedHeight, height: recommendedHeight}}>
                    <div data-src="http://csi.hbz.local/_data/infomodelprofile.png" >1</div>
                    <div data-src="http://csi.hbz.local/_data/classexchangepackage.png">2</div>
                </AwesomeSlider> */}
          </div>
        )
    }
}

export default DiagramGallery;